import { render } from "./IPReport.vue?vue&type=template&id=071d14ac"
import script from "./IPReport.vue?vue&type=script&lang=js"
export * from "./IPReport.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__